import React from 'react';
import Profile from '../components/Profile/Profile';
import MissionCard from '../components/MissionCard/MissionCard';
import DownloadPageButton from '../components/DownloadPageButton/DownloadPageButton';
import ExperienceTimeline from '../components/ExperienceTimeline/ExperienceTimeline';

import profile from '../data/profile.json'
import missions from '../data/missions.json';

import '../styles/global.css';

function CvPage() {
  return (
    <div className="page-wrapper">
      <div className="page">
        <div className="mb-10">
        <Profile
            picture="/profile/firat-kehl.JPEG"
            name={profile.name}
            surname={profile.surname}
            jobTitle={profile.jobTitle}
            description={profile.description}
            languages={profile.languages}
            imageSize={320}
        />
        </div>

        <ExperienceTimeline />

        <section className="mb-8">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-[var(--accent-green)]">
            Experience
          </p>
          <h1 className="mt-2 text-3xl font-bold text-[var(--text-primary)] md:text-4xl">
            Projects, missions, research and teaching
          </h1>
          <p className="mt-3 max-w-3xl text-base leading-relaxed text-[var(--text-secondary)]">
            A timeline of applied AI, cloud engineering, data work, and academic experience.
          </p>
        </section>

        <section className="relative">
          <div className="absolute bottom-0 left-4 top-0 w-px bg-[var(--border-color)] md:left-[11.5rem]" aria-hidden="true" />
          <div className="space-y-8">
            {missions.map((mission, index) => (
              <div key={`${mission.company}-${mission.role}-${mission.date}`} className="relative md:grid md:grid-cols-[10rem_1fr] md:gap-10">
                <div className="hidden pt-6 text-right text-sm font-semibold text-[var(--text-secondary)] md:block">
                  {mission.date}
                </div>
                <div className="absolute left-[0.7rem] top-7 h-3 w-3 rounded-full border-2 border-[var(--accent-gold)] bg-[var(--bg-primary)] shadow md:left-[11.15rem]" aria-hidden="true" />
                <div className="pl-10 md:pl-0">
                  <MissionCard
                    date={mission.date}
                    company={mission.company}
                    role={mission.role}
                    details={mission.details}
                    logo={mission.logo}
                  />
                </div>
              </div>
            ))}
          </div>
        </section>

        <DownloadPageButton />
    </div>
    </div>
  );
}

export default CvPage;
